<div class="shell">
  <div>
    <!-- Banner -->
    <fz-banner
      [user]="user"
      [timeZone]="user?.user?.userSettings?.timezone"
      [tournamentDetails]="casualTournamentDetails$ | async"
      [details]="details() || undefined"
      [actionBarConfig]="{
        showPlayButton: true,
        showTryForFreeButton: true,
        enabledPlayButton: !isLEPT || playButtonStateLoading(),
        playButtonLoading: !isLEPT || playButtonStateLoading(),
        playButtonProcessing: isPlayStarting() || isBuyingPass() || false,
        isEventPage: true
      }"
      [eventScheduler]="currentEventSchedule$ | async"
      [passForTournament]="(activePass$ | async) || undefined"
      [timesPlayed]="timesPlayed"
      [useFloatingBanner]="true"
      [hideTimeOnMobile]="true"
      (tryForFreePress)="onTryForFree()"
      (sharePress)="onShare()"
      (playPress)="onPlay($event)"
    ></fz-banner>

    <fz-conditional
      [loading]="(loadingTournamentDetails$ | async) === false"
      [error]="false"
      [loadingComponent]="loadingBanner"
      [errorComponent]="errorBanner"
      [dataComponent]="banner"
    ></fz-conditional>

    <ng-template #loadingBanner><div class="loading"></div></ng-template>
    <ng-template #errorBanner><div>Error</div></ng-template>
    <ng-template #banner> </ng-template>
  </div>
  <div
    class="container tournament-container"
    *ngIf="currentEventSchedule$ | async as eventSchedule"
  >
    <!-- Navigation Tab Bar -->
    <fz-router-tabs
      [links]="tabsLinks"
      type="query"
      [activeLinkIndex]="getActiveTab()"
    ></fz-router-tabs>

    @switch (view) {
      @case ('open-events') {
        <div class="tab-container__open-events">
          <div class="tab-container__open-events__content">
            @if (tournamentDetails) {
              @defer {
                <fz-open-events-tab
                  [prototypeId]="prototypeId()"
                  [scheduleId]="scheduleId()"
                  [tournamentDetails]="tournamentDetails"
                  [eventSchedule]="eventSchedule"
                  [isAuthenticated]="isAuthenticated() ?? false"
                ></fz-open-events-tab>
              }
            }
          </div>

          <fz-score-summary
            [viewEntryFee]="true"
            [eventCode]="nextEvent()?.eventCode"
            [showSummary]="user?.user !== null && user?.user !== undefined"
            [prizeImage]="eventSchedule?.firstPrize?.prizeImageCard | prizeImage"
            [isLEP]="(casualTournamentDetails$ | async)?.lifeExperience"
            [seats]="eventSchedule?.totalEntryCount"
            [prizeValue]="
              (currentEventSchedule$ | async)?.firstPrize?.prizeValue
            "
            [entryAmount]="eventSchedule.entryAmount"
            [bestScore]="bestScores"
            [eventScheduleDetails]="eventSchedule"
            [metadata]="(casualTournamentDetails$ | async)?.metadata"
          ></fz-score-summary>
        </div>
      }
      @case ('details') {
        <fz-tab-tournament-details
          *ngIf="view === 'details' && eventSchedule.eventScheduleUuid"
          [@slideLeftAnimation]
          [isLEP]="(casualTournamentDetails$ | async)?.lifeExperience"
          [prizeImage]="eventSchedule?.firstPrize?.prizeImageCard | prizeImage"
          [eventScheduleDetails]="eventSchedule"
          [bestScores]="bestScores"
          [eventCode]="nextEvent()?.eventCode"
          [eventRating]="(casualTournamentDetails$ | async)?.rating"
          [showSummary]="user?.user !== null && user?.user !== undefined"
          (share)="onShare()"
          (tryForFree)="onTryForFree()"
          (playGame)="onPlay()"
          [eventPrototypeUuid]="
            (casualTournamentDetails$ | async)?.eventPrototypeUuid
          "
          [casualGameStartTime]="
            (casualTournamentDetails$ | async)?.casualGameStartTime
          "
          [casualGameEndTime]="
            (casualTournamentDetails$ | async)?.casualGameEndTime
          "
          [tournamentPrizeValue]="
            (casualTournamentDetails$ | async)?.metadata?.prizeValue
          "
          [details]="casualTournamentDetails$ | async"
          [playControls]="playControls"
        ></fz-tab-tournament-details>
      }
      @case ('history') {
        <fz-tab-history
          [@slideLeftAnimation]
          [eventCode]="nextEvent()?.eventCode"
          [isLEP]="(casualTournamentDetails$ | async)?.lifeExperience"
          [prizeImage]="eventSchedule?.firstPrize?.prizeImageCard | prizeImage"
          [gameHistory]="gameHistory"
          [isLoggedIn]="loggedIn"
          [eventScheduleDetails]="eventSchedule"
          [bestScores]="bestScores"
          [totalGameHistory]="totalGameHistory$ | async"
          [eventRetired]="eventSchedule?.retired"
          [entryFee]="eventSchedule?.entryAmount"
          [user]="user"
          [loaded]="gameHistoryLoaded$ | async"
          [page]="page"
          (gameHistoryPageChange)="onGameHistoryPageChange($event)"
          (playNow)="onPlay()"
          (share)="onShare()"
          (tryForFree)="onTryForFree()"
          (login)="onLogin()"
          (viewPlayInstance)="onViewGameHistory($event)"
          [eventPrototypeUuid]="
            (casualTournamentDetails$ | async)?.eventPrototypeUuid
          "
          [casualGameStartTime]="
            (casualTournamentDetails$ | async)?.casualGameStartTime
          "
          [casualGameEndTime]="
            (casualTournamentDetails$ | async)?.casualGameEndTime
          "
          [details]="casualTournamentDetails$ | async"
          [playControls]="playControls"
        ></fz-tab-history>
      }
      @case ('leaderboard') {
        @if ((casualTournamentDetails$ | async)?.lifeExperience) {
          <fz-tab-leaderboard
            [eventCode]="nextEvent()?.eventCode"
            [@slideLeftAnimation]
            [eventSchedulePrizes]="eventSchedulePrizes$ | async"
            [leaders]="leaderBoard"
            [total]="totalLeaderBoard$ | async"
            [loaded]="leaderBoardLoaded$ | async"
            [loading]="this.leaderBoardLoading$ | async"
            [isLEP]="(casualTournamentDetails$ | async)?.lifeExperience"
            [prizeImage]="eventSchedule?.firstPrize?.prizeImageCard | prizeImage"
            [entryAmount]="(currentEventSchedule$ | async)?.entryAmount"
            [prizeValue]="
              (currentEventSchedule$ | async)?.firstPrize?.prizeValue
            "
            [seats]="eventSchedule?.totalEntryCount"
            [bestScores]="bestScores"
            [showScores]="showScores"
            [isLoggedIn]="loggedIn"
            [user]="user"
            [page]="leaderBoardPage"
            [retired]="eventSchedule.retired"
            [entryAmount]="eventSchedule.entryAmount"
            (leaderboardPageChange)="onLeaderboardPageChange($event)"
            (share)="onShare()"
            (tryForFree)="onTryForFree()"
            (playGame)="onPlay()"
            (loginEvent)="onLogin()"
            [eventPrototypeUuid]="
              (casualTournamentDetails$ | async)?.eventPrototypeUuid
            "
            [casualGameStartTime]="
              (casualTournamentDetails$ | async)?.casualGameStartTime
            "
            [casualGameEndTime]="
              (casualTournamentDetails$ | async)?.casualGameEndTime
            "
            (loginEvent)="onLogin()"
            [eventSchedule]="eventSchedule"
            [playControls]="playControls"
            [casualTournamentDetails]="casualTournamentDetails$ | async"
          ></fz-tab-leaderboard>
        }
      }
      @case ('rules') {
        <fz-tab-rules
          [@slideLeftAnimation]
          [eventCode]="nextEvent()?.eventCode"
          [isLEP]="(casualTournamentDetails$ | async)?.lifeExperience"
          [prizeImage]="eventSchedule?.firstPrize?.prizeImageCard | prizeImage"
          [tournamentRules]="
            (casualTournamentDetails$ | async)?.metadata?.tournamentRules
          "
          [eventScheduleDetails]="eventSchedule"
          [bestScores]="bestScores"
          [retired]="eventSchedule.retired"
          [entryAmount]="eventSchedule.entryAmount"
          [user]="user"
          (share)="onShare()"
          (tryForFree)="onTryForFree()"
          (playGame)="onPlay()"
          [eventPrototypeUuid]="
            (casualTournamentDetails$ | async)?.eventPrototypeUuid
          "
          [casualGameStartTime]="
            (casualTournamentDetails$ | async)?.casualGameStartTime
          "
          [casualGameEndTime]="
            (casualTournamentDetails$ | async)?.casualGameEndTime
          "
          [details]="casualTournamentDetails$ | async"
          [playControls]="playControls"
        ></fz-tab-rules>
      }
      @default {
        <fz-tab-overview
          [@slideLeftAnimation]
          [eventCode]="nextEvent()?.eventCode"
          [isLEP]="(casualTournamentDetails$ | async)?.lifeExperience"
          [details]="casualTournamentDetails$ | async"
          [eventScheduleDetails]="eventSchedule"
          [tournamentPasses]="(passForTournament$ | async) || undefined"
          [tournamentPassesLoaded]="(passForTournamentLoaded$ | async) || false"
          [prizeImage]="eventSchedule?.firstPrize?.prizeImageCard | prizeImage"
          [timesPlayed]="timesUserTournamentPlayed$ | async"
          (buyPass)="buyPassForTournament($event)"
          [bestScores]="bestScores"
          [gameInfo]="(casualTournamentDetails$ | async)?.game"
          [user]="user"
          [eventPrototypeUuid]="
            (casualTournamentDetails$ | async)?.eventPrototypeUuid
          "
          (share)="onShare()"
          (sharePass)="onSharePass($event)"
          (tryForFree)="onTryForFree()"
          (playGame)="onPlay($event)"
          [casualGameEndTime]="
            (casualTournamentDetails$ | async)?.casualGameEndTime
          "
          [playControls]="playControls"
        ></fz-tab-overview>
      }
    }
  </div>
</div>

<!-- one play action for all tabs view -->
<!-- templates -->
<ng-template #playControls>
  <fz-tournament-controls
    [showPlayButton]="true"
    [showShareButton]="true"
    [showTryForFreeButton]="true"
    [showBecomeZboButton]="true"
    [activePass]="(activePass$ | async) || undefined"
    [shareMode]="'button'"
    [timesPlayed]="timesPlayed"
    [entryAmount]="currentEventSchedule?.entryAmount || 0"
    [tournamentDetails]="casualTournamentDetails$ | async"
    [eventScheduler]="currentEventSchedule"
    [user]="user"
    (sharePress)="onShare()"
    (playPress)="onPlay($event)"
    (tryForFreePress)="onTryForFree()"
    [enabledPlayButton]="!isLEPT || playButtonStateLoading()"
    [playButtonLoading]="!isLEPT || playButtonStateLoading()"
  ></fz-tournament-controls>
</ng-template>
